import React from 'react';
import styled from 'styled-components';

const ArrowStyle = styled.div`
  cursor: pointer;
`;

interface IArrow {
  style?: any;
  ref?: string;
  onClick?: (e: any) => void;
}
const Arrow: React.FC<IArrow> = (props) => {
  return (
    <ArrowStyle onClick={props.onClick}>
      <svg
        style={props.style}
        width="37"
        height="20"
        viewBox="0 0 37 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.537128 0.537647C0.833416 0.241358 1.10078 0 1.13116 0C1.16154 0 5.06241 3.87649 9.80026 8.61545C14.5381 13.3533 18.4405 17.2309 18.4708 17.2309C18.5012 17.2309 22.4036 13.3544 27.1414 8.61545C31.8793 3.8776 35.7946 0 35.8409 0C35.9493 0 37 1.05221 37 1.16058C37 1.20538 32.8375 5.40559 27.75 10.4931L18.5 19.7431L9.25 10.4931C4.1625 5.40559 0 1.20535 0 1.1591C0 1.11285 0.242813 0.833902 0.539089 0.53761L0.537128 0.537647Z"
          fill="url(#paint0_linear_5_258)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5_258"
            x1="-18.9625"
            y1="7.00191"
            x2="35.2491"
            y2="18.2846"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#834628" />
            <stop offset="0.34375" stopColor="#824528" />
            <stop offset="0.572917" stopColor="#D7A87C" />
            <stop offset="0.791667" stopColor="#9C603F" />
            <stop offset="1" stopColor="#9A5E3D" />
          </linearGradient>
        </defs>
      </svg>
    </ArrowStyle>
  );
};

export default Arrow;
